import { SttFragment } from '@ftr/contracts/regional-api/stt'
import { assert } from '@ftr/contracts/shared/Assertions'
import { SttEdit, UpsertUtteranceSttEdit } from '@ftr/regional-api-contracts'
import { Duration, LocalDateTime } from '@js-joda/core'
import { RealTimeSttSegmentMap } from '../../../types'

export const UNIQUE_START_TIME_BUMP_DURATION: Duration = Duration.ofMillis(1)

export function bumpStartTimeEditsToProduceUniqueTime(
  reservedTime: LocalDateTime,
  segmentMap: RealTimeSttSegmentMap,
  bumpDirection: 'forward' | 'backward',
): SttEdit[] {
  const remarkAtReservedTime = segmentMap
    .getSegmentAt(reservedTime)
    ?.remarksArray.find(x => x.startTime.equals(reservedTime))
  if (!remarkAtReservedTime) {
    return []
  }

  assert(remarkAtReservedTime.fragments && remarkAtReservedTime.fragments.length)
  const newStartTime =
    bumpDirection === 'forward'
      ? remarkAtReservedTime.startTime.plus(UNIQUE_START_TIME_BUMP_DURATION)
      : remarkAtReservedTime.startTime.minus(UNIQUE_START_TIME_BUMP_DURATION)
  const shouldBumpStartTime = (time: LocalDateTime): boolean => {
    return bumpDirection === 'forward' ? time.isBefore(newStartTime) : time.isAfter(newStartTime)
  }
  const newFragments: SttFragment[] = remarkAtReservedTime.fragments.map(fragment => ({
    content: fragment.content,
    startTime: shouldBumpStartTime(fragment.startTime) ? newStartTime : fragment.startTime,
    // Only bump end time if required to ensure start <= end
    endTime: fragment.endTime.isBefore(newStartTime) ? newStartTime : fragment.endTime,
  }))

  const edit: UpsertUtteranceSttEdit = {
    type: 'upsertUtterance',
    utteranceId: remarkAtReservedTime.id,
    dialect: remarkAtReservedTime.dialect ?? null,
    speakerId: remarkAtReservedTime.speakerId,
    fragments: newFragments,
  }

  return [edit, ...bumpStartTimeEditsToProduceUniqueTime(newStartTime, segmentMap, bumpDirection)]
}
